import ModuleHeader from "../../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../../config/usePrivateLink";
import TestTabs from "./TestTabs";

export default function TestLayout({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const visibleTabs = TestTabs.filter((tab) => {
    const routes = tab.activePaths?.length
      ? tab.activePaths
      : [tab.path];

    return routes.some((route) => hasAccess(route));
  });

  return (
    <div className="mt-4">
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </div>
  );
}